export default function Orders() {
  const orders = JSON.parse(localStorage.getItem("orders") || "[]");

  if (orders.length === 0) {
    return (
      <div className="container">
        <h2>No orders yet</h2>
        <p>Your past orders will appear here.</p>
      </div>
    );
  }

  return (
    <div className="container">
      <h1>My Orders</h1>

      {orders.map((order: any) => (
        <div key={order.orderId} className="card">
          <h3>Order ID: {order.orderId}</h3>
          <p>
            <strong>Date:</strong> {new Date(order.date).toLocaleDateString()}
          </p>
          <p>
            <strong>Total:</strong> ₹{order.subtotal}
          </p>

          <div style={{ marginTop: "10px" }}>
            <strong>Items:</strong>
            <ul>
              {order.items.map((item: any) => (
                <li key={item.id}>
                  {item.name} × {item.quantity}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
}
